<div
  class="confirm-modal"
  *ngIf="open"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'confirm-modal-title'"
  (mousedown)="onBackdropMouseDown($event)">
  <div class="confirm-modal__panel" (mousedown)="$event.stopPropagation()">
    <button type="button" class="confirm-modal__close" (click)="cancel()" aria-label="Fermer">
      <mat-icon>close</mat-icon>
    </button>

    <div class="confirm-modal__body">
      <span
        class="confirm-modal__icon"
        [class.confirm-modal__icon--danger]="destructive"
        aria-hidden="true">
        <mat-icon>{{ icon }}</mat-icon>
      </span>
      <h2 id="confirm-modal-title">{{ title }}</h2>
      <p class="confirm-modal__message" *ngIf="message">{{ message }}</p>
    </div>

    <footer class="confirm-modal__actions">
      <button type="button" class="confirm-modal__btn confirm-modal__btn--ghost" (click)="cancel()">
        {{ cancelLabel }}
      </button>
      <button
        type="button"
        class="confirm-modal__btn"
        [class.confirm-modal__btn--primary]="!destructive"
        [class.confirm-modal__btn--danger]="destructive"
        (click)="confirm()">
        {{ confirmLabel }}
      </button>
    </footer>
  </div>
</div>
